<h1 mat-dialog-title>
  {{ "LOGOUT.DIALOG.TITLE" | translate }}
</h1>
<mat-dialog-content>
  {{ "LOGOUT.DIALOG.CONTENT" | translate }}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matButton="outlined" [mat-dialog-close]>
    {{ "LOGOUT.DIALOG.CANCEL" | translate }}
  </button>
  &nbsp;
  <button mat-flat-button color="warn" [mat-dialog-close]="true">
    {{ "LOGOUT.DIALOG.OK" | translate }}
  </button>
</mat-dialog-actions>
